import Loader from 'components/Loader'
import styled from 'styled-components'
import { useTheme } from 'styled-components'
import { ThemedText } from 'theme'

const BaultStatCard = styled.div`
  padding: 10px;
  background: ${({ theme }) => theme.backgroundSurface};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
`

interface StatProps {
  label: string
  value: string | undefined | null
  subValue?: string | undefined
  color?: string
  isLoading?: boolean
  hasError?: boolean
  errorMessage?: string
}

const Stat = ({
  label,
  value,
  subValue,
  color,
  isLoading = false,
  hasError = false,
  errorMessage = 'Error',
}: StatProps) => {
  const theme = useTheme()

  return (
    <BaultStatCard>
      <ThemedText.DeprecatedBody fontSize="12px" color={theme.textSecondary}>
        {label}
      </ThemedText.DeprecatedBody>
      <ThemedText.DeprecatedMediumHeader color={color || theme.textPrimary}>
        {hasError ? (
          <span style={{ color: theme.textSecondary, fontSize: '12px' }}>{errorMessage}</span>
        ) : isLoading ? (
          <Loader />
        ) : (
          value || 'N/A'
        )}
      </ThemedText.DeprecatedMediumHeader>
      {subValue && !isLoading && !hasError && (
        <ThemedText.DeprecatedBody fontSize="10px" color={theme.textSecondary}>
          {subValue}
        </ThemedText.DeprecatedBody>
      )}
    </BaultStatCard>
  )
}

export default Stat
